function resolveLocale(prefLang, paramLang, browserLangs, available) {
  if (prefLang && prefLang !== "auto") {
    return prefLang;
  }

  if (prefLang === "auto") {
    const supported = available || [];
    const storefrontLang = Array.isArray(paramLang) ? paramLang[0] : paramLang;

    if (typeof storefrontLang === "string") {
      const primary = storefrontLang.trim().toLowerCase().split("-")[0];
      const locale = primary === "cs" ? "cz" : primary;

      if (supported.includes(locale)) {
        return locale;
      }
    }

    for (const tag of (browserLangs || []).filter(Boolean)) {
      const primary = tag.split("-")[0].toLowerCase();
      const locale = primary === "cs" ? "cz" : primary;

      if (supported.includes(locale)) {
        return locale;
      }
    }

    return "en";
  }

  return "ro";
}

module.exports = { resolveLocale };
